// Group bank/queue panels by job number. A job is "priority" if any of its
// panels are priority. Priority jobs float to the top; within a job, priority
// panels float to the top.
export function groupByJob(panels) {
  const map = {};
  (panels || []).forEach((p) => {
    const job = p.jobNumber || "No Job #";
    (map[job] = map[job] || []).push(p);
  });
  const groups = Object.entries(map).map(([job, items]) => {
    const priority = items.some((p) => p.priority);
    const sorted = [...items].sort(
      (a, b) => (b.priority ? 1 : 0) - (a.priority ? 1 : 0) || a.name.localeCompare(b.name)
    );
    return { job, items: sorted, priority };
  });
  groups.sort((a, b) => (b.priority ? 1 : 0) - (a.priority ? 1 : 0) || a.job.localeCompare(b.job));
  return groups;
}
